export const useBannerFilter = (config: any, banners: any[]) => {
  const { isTablet, isDesktop } = useDevice();
  const deviceType = isDesktop ? 'desktop' : isTablet ? 'tablet' : 'mobile';

  return config
    .filter((configItem: any) => configItem.visibility[deviceType])
    .sort((a: any, b: any) => a.sequence_number - b.sequence_number)
    .map((configItem: any) => ({
      ...configItem,
      banners: getSortedBanners(configItem.id, banners),
    }));
}

const getSortedBanners = (parentId: any, cmsBanners: any[] = []) => {
  return cmsBanners
    .filter(item => item.scope?.some((scope: any) => scope.type === 'parent_id' && scope.values.includes(parentId)))
    .map(item => ({
      ...item,
      sequence_number: item.scope?.find((scope: any) => scope.type === 'parent_id')?.sequence_number || null,
      parent: { id: parentId },
    }))
    .sort((a, b) => a.sequence_number - b.sequence_number);
}
